import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

export default ({ data }) => (
  <div className="clearfix">
    <table className="days-display table">
      <thead>
        <tr>
          {/* <td rowSpan="2"><FormattedMessage {...messages.fio}/></td> */}
          <td rowSpan="2">
            <FormattedMessage {...messages.position} />
          </td>
          <td colSpan="2">
            <FormattedMessage {...messages.receptDays} />
          </td>
          <td rowSpan="2">
            <FormattedMessage {...messages.phone2} />
          </td>
          {/* <td rowSpan="2"><FormattedMessage {...messages.email2}/></td> */}
        </tr>
        <tr>
          <td>
            <FormattedMessage {...messages.days} />
          </td>
          <td>
            <FormattedMessage {...messages.time} />
          </td>
        </tr>
      </thead>
      <tbody>
        {data.heads.map((day, i) => {
          const [first, ...rest] = day.linkAuthorityHeadsReceptionDays;
          return (
            <React.Fragment key={i}>
              {first && (
                <tr>
                  {/*  <td>{day.head_title}</td> */}
                  <td rowSpan={day.linkAuthorityHeadsReceptionDays.length}>{day.head_position}</td>
                  <td>{first.reception_day}</td>
                  <td>
                    {first.reception_time_from.slice(0, 5)} - {first.reception_time_to.slice(0, 5)}
                  </td>

                  <td rowSpan={day.linkAuthorityHeadsReceptionDays.length}>{day.head_phone}</td>
                  {/* <td>{day.email}</td> */}
                </tr>
              )}
              {rest.map((item, index) => (
                <tr key={index}>
                  <td style={{ paddingLeft: 0 }}>
                    <div style={{ textAlign: 'center' }}>{item.reception_day}</div>
                  </td>
                  <td>
                    {item.reception_time_from.slice(0, 5)} - {item.reception_time_to.slice(0, 5)}
                  </td>
                </tr>
              ))}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./src/apps/authorities/views/_days.js